import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IProjectRegistrationPartner } from './../../shared/interfaces/projectRegistration.Interfaces';

@Injectable()
export class HomeInspectionCertificationService {
    serviceBase =environment.API_URL+ '/api/registerProject';
    
    queryString: string;
    constructor(private http: HttpClient) { }

    // Get partner
    getPartner(masterProjectId: any, selectedLanguage: string) {
        this.queryString = '/getPartner?masterProjectId=' + masterProjectId + "&selectedLanguage=" + selectedLanguage;
        return this.http.get<Array<IProjectRegistrationPartner>>(this.serviceBase + this.queryString);
    }


}
